import type { Moment } from 'moment';
import { convertToDateTime } from 'util/transformers';
import { UiDateTimeFormatter } from 'util/formaters';
import type { Merchant } from 'features/ecommerce/types';
import { OnboardingEntity } from 'features/ecommerce/OnboardingEntity';

export class Identity extends OnboardingEntity {
    public readonly fullName: string;
    public readonly dateOfBirth: Moment | null;
    public readonly residentialAddress: string;
    public readonly nationality: string | null;
    public readonly identityFileKey: string | null;
    public readonly addressFileKey: string | null;
    public readonly legalForm: string | null;

    public constructor({
        fullName = '',
        residentialAddress = '',
        nationality = null,
        identityFileKey = null,
        addressFileKey = null,
        dateOfBirth = null,
        legalForm = null,
        ...rest
    } = {} as Partial<Merchant.UboIdentity>) {
        super(rest);

        this.fullName = fullName;
        this.dateOfBirth = convertToDateTime(dateOfBirth, UiDateTimeFormatter.Ui);
        this.residentialAddress = residentialAddress;
        this.nationality = nationality;
        this.identityFileKey = identityFileKey;
        this.addressFileKey = addressFileKey;
        this.legalForm = legalForm;
    }
};

export default Identity;
